import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34175ab1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-select-component select-default" }
const _hoisted_2 = {
  key: 0,
  class: "error-info"
}
const _hoisted_3 = {
  key: 0,
  class: "placeholder-message"
}
const _hoisted_4 = {
  key: 1,
  class: "selected-option"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "error-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass(["field-label", { disabled: _ctx.disabled }])
        }, [
          (_ctx.requiredSign)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true),
          _createTextVNode(_toDisplayString(_ctx.label), 1)
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.searchable)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["fake-input", { 'has-error': _ctx.hasError && !_ctx.disabled, disabled: _ctx.disabled, 'border-active': _ctx.openOptions }]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleOptions && _ctx.toggleOptions(...args)))
        }, [
          (!_ctx.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.placeholder), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.selectedLabel), 1)),
          (_ctx.openOptions && !_ctx.searchTerm)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                class: _normalizeClass({ 'has-error': _ctx.hasError }),
                src: _ctx.arrowUpIconPath
              }, null, 10, _hoisted_5))
            : (_openBlock(), _createElementBlock("img", {
                key: 3,
                class: _normalizeClass({ 'has-error': _ctx.hasError, 'clear-input-icon': _ctx.openOptions && _ctx.searchTerm }),
                src: _ctx.openOptions && _ctx.searchTerm ? _ctx.xmarkIconPath : _ctx.dropdownIconPath,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearInput(!_ctx.openOptions)))
              }, null, 10, _hoisted_6))
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.searchable)
      ? (_openBlock(), _createBlock(_component_base_input, {
          key: 2,
          class: _normalizeClass(["search-input", { 'disabled': _ctx.disabled, 'arrow-up-icon': _ctx.openOptions, 'changeIcon': _ctx.openOptions && (_ctx.searchTerm || _ctx.selectedLabel || _ctx.disabled)}]),
          type: "text",
          iconAfter: "",
          placeholder: _ctx.openOptions && _ctx.selectedLabel ? _ctx.selectedLabel : _ctx.placeholder,
          forceError: _ctx.hasError,
          disabled: _ctx.disabled,
          modelValue: _ctx.searchTerm,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchTerm) = $event)),
          onFocus: _ctx.focusSearch,
          onKeyup: _ctx.keyUpSearch,
          onBlur: _ctx.delayedBlur,
          requiredSign: ""
        }, {
          "x-mark-icon": _withCtx(() => [
            (_ctx.openOptions && ( _ctx.searchTerm || _ctx.selectedLabel))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearInput && _ctx.clearInput(...args)))
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass({ 'clear-input-icon position-absolute':  _ctx.searchTerm || _ctx.selectedLabel } ),
                    src: _ctx.xmarkIconPath
                  }, null, 10, _hoisted_7)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class", "placeholder", "forceError", "disabled", "modelValue", "onFocus", "onKeyup", "onBlur"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["options-container", { closed: !_ctx.openOptions || _ctx.disabled }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtredOptions, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "option",
          key: option[_ctx.keyValue],
          onClick: ($event: any) => (_ctx.selectOption(option))
        }, _toDisplayString(option[_ctx.keyLabel]), 9, _hoisted_8))
      }), 128))
    ], 2),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _createElementVNode("span", null, _toDisplayString(_ctx.errorMsg), 1)
    ], 512), [
      [_vShow, _ctx.hasError && !_ctx.disabled]
    ])
  ]))
}